
import React from 'react';

// Styles & Assets
import styles from './ToolbarUserAdministration.module.css';
import { MdEdit } from 'react-icons/md';
import { RiFilterFill } from 'react-icons/ri';

// Hooks
import useSearchbar from '../../../hooks/useSearchbar';

// Components
import FilterUsersDialog from '../../../components/UserAdministrationPage/FilterUsersDialog/FilterUsersDialog';
import ButtonToolbar from '../../../components/UI/ButtonToolbar/ButtonToolbar';
import FilterColumnsUsersDialog from '../../../components/UserAdministrationPage/FilterColumnsUsersDialog/FilterColumnsUsersDialog';
import Searchbar from '../../../components/UI/Searchbar/Searchbar';
import Toolbar from '../../../components/UI/Toolbar/Toolbar';
import CheckboxGrid from '../../../components/UI/CheckboxGrid/CheckboxGrid';

// Interfaces
import { UserData, UsersFiltersDispatch } from '../../../interfaces/UserInfo';
import { Column } from '../../../interfaces/Columns';

// Language
import { useTranslation } from 'react-i18next';
import { FiltersUsers } from '../../../interfaces/Filters';

const ToolbarUserAdministration: React.FC<{
    filtersUsers: FiltersUsers,
    dispatchUsersFilters: React.Dispatch<UsersFiltersDispatch>
    columnsUser: Column<UserData>[],
    toggleUsersVisibleColumn: (id: number) => void
}> = ({ filtersUsers, dispatchUsersFilters, columnsUser, toggleUsersVisibleColumn }) => {

    const { t } = useTranslation();

    const getFilter = useSearchbar(columnsUser);

    const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        dispatchUsersFilters({ type: 'SEARCHBAR', filter: getFilter(evt.target.value) });
    };

    const defaultFilterActive =
        filtersUsers.currentFiltersActive.some(filter => filter) ||
        filtersUsers.currentFiltersRole.some(filter => filter);

    return (
        <Toolbar text={t('administration')} link='/home/administration'>
            <div className={styles.userAdministrationToolbar}>
                <div className={styles.filtersContainer}>
                    <Searchbar handleChange={handleChange} />
                    <ButtonToolbar
                        icon={<RiFilterFill />}
                        label={t('filter')}
                        defaultFilterActive={defaultFilterActive}
                    >
                        <FilterUsersDialog
                            filtersUsers={filtersUsers}
                            dispatchUsersFilters={dispatchUsersFilters}
                            modalShow={() => undefined}
                            setFilterBallActive={() => undefined}
                        />
                    </ButtonToolbar>
                    <ButtonToolbar
                        icon={<MdEdit />}
                        label={t('custom_columns')}
                    >
                        <FilterColumnsUsersDialog
                            modalShow={() => undefined}
                        >
                            <CheckboxGrid
                                columns={columnsUser}
                                toggleVisibility={toggleUsersVisibleColumn}
                            />
                        </FilterColumnsUsersDialog>
                    </ButtonToolbar>
                    {/* <ButtonRoleAdmin /> */}
                </div>
            </div>
        </Toolbar>
    );
};

export default ToolbarUserAdministration;